import { SiteAssetsModuleName } from '@wix/thunderbolt-symbols'

export const siteAssetsModules: Array<SiteAssetsModuleName> = [
	'thunderbolt-features',
	'thunderbolt-css',
	'thunderbolt-css-mappers',
	'thunderbolt-platform',
	'thunderbolt-site-map',
	'thunderbolt-mobile-app-builder',
	'builder-component-features',
	'builder-component-css',
	'builder-component-platform',
	'component-manifest-css',
]
